var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [!_vm.isAmbienteRoute ? _c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Nome',
        field: 'nome'
      }, {
        type: 'text',
        label: 'Ambiente',
        field: 'ambiente_nome'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Todos', 'Livre', 'Ocupada', 'Reservada', 'Inativa']
      }, {
        type: 'select',
        label: 'Ativo',
        field: 'ativo',
        options: ['Todos', 'Ativo', 'Inativo']
      }]
    }
  }) : _vm._e(), _c('TableApp', {
    ref: "mesas",
    attrs: {
      "titulo": _vm.tituloTabela,
      "acaoBtn": _vm.novaMesaUrl,
      "textoBtn": "Novo",
      "secondaryButtonUrl": _vm.secondaryButtonUrl,
      "secondaryButtonText": _vm.secondaryButtonText,
      "api-url": "/restaurante/mesas",
      "fields": _vm.fields,
      "extraParams": _vm.tableExtraParams,
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'status' ? _c('span', [_c('span', {
          class: _vm.statusClass(props.rowData.status)
        }, [_vm._v(" " + _vm._s(_vm.statusLabel(props.rowData.status)) + " ")])]) : _vm._e(), props.field == 'ativo' ? _c('span', [props.rowData.ativo == true ? _c('span', {
          staticClass: "label label-lg label-inline label-light-success"
        }, [_vm._v("Ativo")]) : _c('span', {
          staticClass: "label label-lg label-inline label-light-danger"
        }, [_vm._v("Inativo")])]) : _vm._e(), props.field == 'actions' ? _c('span', [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "170px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [_c('router-link', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Editar',
            expression: "'Editar'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "to": _vm.mesaEditRoute(props.rowData)
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Excluir',
            expression: "'Excluir'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'QR Code',
            expression: "'QR Code'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-primary btn-hover-primary btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.abrirQrCode(props.rowData);
            }
          }
        }, [_c('QrcodeIcon', {
          attrs: {
            "size": 16
          }
        })], 1)], 1)])])]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "title": "QR Code do Self Pedido",
      "size": "md",
      "centered": "",
      "hide-footer": ""
    },
    model: {
      value: _vm.qrCodeModalVisible,
      callback: function callback($$v) {
        _vm.qrCodeModalVisible = $$v;
      },
      expression: "qrCodeModalVisible"
    }
  }, [_vm.qrCodeLoading ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('span', {
    staticClass: "spinner spinner-primary spinner-lg"
  })]) : _vm.qrCodeData ? _c('div', [_vm.qrCodeUrl ? _c('div', {
    ref: "selfPedidoQrPrint",
    staticClass: "self-pedido-qr-print text-center"
  }, [_c('h4', {
    staticClass: "mb-2"
  }, [_vm._v("Self Pedido")]), _c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Mesa:")]), _vm._v(" " + _vm._s(_vm.qrCodeMesaTitulo))]), _vm.qrCodeAmbiente ? _c('p', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Ambiente:")]), _vm._v(" " + _vm._s(_vm.qrCodeAmbiente) + " ")]) : _vm._e(), _c('div', {
    staticClass: "self-pedido-qr-box"
  }, [_c('QrCodeVue', {
    attrs: {
      "value": _vm.qrCodeUrl,
      "size": 240,
      "level": "M"
    }
  })], 1), _c('p', {
    staticClass: "self-pedido-qr-url mt-4 mb-0"
  }, [_vm._v(_vm._s(_vm.qrCodeUrl))])]) : _c('div', {
    staticClass: "alert alert-danger mb-0",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" A API não retornou a URL pública do Self Pedido. Configure a origem pública antes de gerar ou imprimir este QR Code. ")]), !_vm.qrCodeData.self_pedido.ativo ? _c('div', {
    staticClass: "alert alert-warning mt-4 mb-0"
  }, [_vm._v(" Self Pedido está inativo em Cardápio Digital > Atendimento. ")]) : _vm._e(), _vm.qrCodeUrl ? _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('button', {
    staticClass: "btn btn-light-primary btn-sm mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copiarQrCodeUrl
    }
  }, [_c('ContentCopyIcon', {
    staticClass: "mr-1",
    attrs: {
      "size": 16
    }
  }), _vm._v(" Copiar URL ")], 1), _c('a', {
    staticClass: "btn btn-light-info btn-sm mr-2",
    attrs: {
      "href": _vm.qrCodeUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('OpenInNewIcon', {
    staticClass: "mr-1",
    attrs: {
      "size": 16
    }
  }), _vm._v(" Abrir ")], 1), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.imprimirQrCode
    }
  }, [_c('PrinterIcon', {
    staticClass: "mr-1",
    attrs: {
      "size": 16
    }
  }), _vm._v(" Imprimir ")], 1)]) : _vm._e()]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };